if (!customElements.get('main-banner-with-text')) {
  class MainBannerWithText extends HTMLElement {
    constructor() {
      super();
      this.bannerBtn = this.querySelector('.image-banner__btn');
      if (this.bannerBtn && this.bannerBtn.classList.contains('image-banner__scroll')) {
        this.bannerBtn.addEventListener('click', (event) => {
          event.preventDefault();
          this.scrollToSection(event.target);
        });
      } else {
        console.log('console.log');
      }
      this.submitEmail();
    }

    scrollToSection(button) {
      const sectionId = button.getAttribute('href');
      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
    submitEmail() {
      const bannerForm = this.querySelector('#banner__form');
      if (bannerForm) {
        bannerForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const emailInput = bannerForm.querySelector('.image-banner__input');
          const email = emailInput.value;
          const popUp = document.querySelector('.pop-up__modal');
          popUp.classList.add('pop-up__modal--active');
          document.body.style.overflow = 'hidden';
          const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
          const data = `g=RADyVV&email=${encodeURIComponent(email)}&$fields=$source&$source=Account Creation`;
          fetch(url, {
            method: 'POST',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded',
              'Cache-Control': 'no-cache',
            },
            body: data,
          })
            .then((response) => response.text())
            .then(() => {
              emailInput.setAttribute('disabled', '');
              const emailBtn = this.querySelector('.image-banner__input-btn');
              emailBtn.setAttribute('disabled', '');
              setTimeout(() => {
                window.open('https://calendly.com/san-nomads/30-min-meeting', '_blank');
              }, 1000);
            })
            .catch((error) => {
              console.error(error);
            });
          this.closePopup();
        });
      }
    }
    closePopup() {
      const popUp = document.querySelector('.pop-up__modal');
      popUp.addEventListener('click', () => {
        popUp.classList.remove('pop-up__modal--active');
        document.body.style.overflow = '';
      });
    }
  }
  customElements.define('main-banner-with-text', MainBannerWithText);
}
